import {Injectable} from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import {catchError, Observable, tap, throwError} from "rxjs";
import {map} from "rxjs/operators";
import {ErrorState} from "../store/error/error.state";
import {SKIP_ERROR_TOAST} from "./client-config.service";

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {

  constructor(private errorState: ErrorState) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        tap(res => {
          //console.log("Error Interceptor Response", res)
        }),
        catchError((error: HttpErrorResponse) => {
          let problem = null;
          let pd = null;
          if (!error.error){
            console.log('This is HTTP no body error', error);
            pd = {
              instance: new Date().toISOString(),
              title: error.message
            }
          }
          else if (error.error instanceof ErrorEvent) {
            console.log('This is client side error', error.error);
            pd = {
              instance: new Date().toISOString(),
              title: error.error.message
            }
          } else if (error.error instanceof ProgressEvent) {
            console.log('This is HTTP progress error', error.error);
            pd = {
              instance: new Date().toISOString(),
              title: error.message
            }
          } else {
            console.log('This is server side error', error);
            if (error.error instanceof Object){
                pd = error.error;
            }
            else{
              pd = JSON.parse(error.error)
            }

            pd.instance ??= new Date().toISOString();
            pd.title ??= pd.message;
          }
          // Requests carrying SKIP_ERROR_TOAST (e.g. ClientConfigService's cold-boot
          // fetch) fall back silently on failure — no user-facing banner (T-016 AC-3).
          if (!request.context.get(SKIP_ERROR_TOAST)) {
            this.errorState.add(pd)
          }
          return throwError(pd);
        })
      )
  }
}
